angular.module('backOffice').controller('ApproveRejectController', approveRejectController);

approveRejectController.$inject = ['$scope', '$modalInstance', 'type'];

function approveRejectController($scope, $modalInstance, type) {
    $scope.type = type;
    // this will dismiss the window.

    $scope.cancel = function () {
        $modalInstance.dismiss();
    };

    // this will remove the beneficiary
    $scope.save = function () {
        $modalInstance.close($scope.comments);
    };
}
